



























































import { defineComponent, getCurrentInstance, onMounted, ref } from '@vue/composition-api';
import { LogoutIcon, FolderIcon } from 'tdesign-icons-vue';

import FileCollectResultDialog from '@/renderer/components/dialog/FileCollect/components/FileCollectResultDialog.vue';
import FileCollectFormDialog from '@/renderer/components/dialog/FileCollect/components/FileCollectFormDialog.vue';
import FileCollectInfoDialog from '@/renderer/components/dialog/FileCollect/components/FileCollectInfoDialog.vue';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';

import dynamicOpenHandler from '@/renderer/components/drawer/Dynamic/composition/dynamicOpenHandler';
import fileCollectDialogHandler from '@/renderer/components/dialog/FileCollect/composition/fileCollectDialogHandler';

import ipc from '@/renderer/scripts/utils/ipc';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { IS_PC } from '@/common/constant/platform';
import { DomainItem } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import { getCustomDomainOrWebUrl } from '@/renderer/scripts/utils/CustomDomain/customDomain';

import CollectedFileTable from './components/CollectedFileTable.vue';
import LaunchFileTable from './components/LaunchFileTable.vue';
export default defineComponent({
  name: 'FileCollectPage',
  components: {
    BaseIcon,
    FolderIcon,
    LogoutIcon,
    FileCollectResultDialog,
    FileCollectFormDialog,
    FileCollectInfoDialog,
    LaunchFileTable,
    CollectedFileTable,
  },
  setup(_, context) {
    const resultInfo = ref({});
    const collectId = ref(-1);
    const vm = getCurrentInstance()?.proxy || context.root;
    const { $store } = vm;
    const router = vm.$router;
    const { query } = router.currentRoute;
    const tabValue = ref(query.tab || 'hasLaunched');
    const previousRoute = ref();
    const { fileCollectDialog, fileColleDialogMethods } = fileCollectDialogHandler();
    dynamicOpenHandler();
    onMounted(() => {
      const { previousRoute: preRouter } = $store.getters;
      previousRoute.value = preRouter;
    });
    const methods = {
      tabChange(val: string) {
        tabValue.value = val;
        router.replace({
          query: {
            tab: val,
          },
        });
      },
      goBack() {
        if (IS_PC) {
          if (previousRoute.value.name === vm.$route.name) {
            dispatchRouter({
              name: 'workbench',
            });
            return;
          }
          dispatchRouter(previousRoute.value);
          return;
        }
        router.go(-1);
      },
      launchCollection() {
        collectId.value = -1;
        fileColleDialogMethods.toggleDialogVisible('showForm', true);
        reporter.report('task_start', {
          start_way: 'tool_box',
        });
      },
      onSaveFileCollectForm(res: { code: string; joinType: number; domains: DomainItem[] }) {
        const { code, joinType, domains } = res;
        const domain = getCustomDomainOrWebUrl(domains);
        Object.assign(fileCollectDialog, { code, joinType, domain });
        fileColleDialogMethods.toggleDialogVisible('showResult', true);
        ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH);
      },
      openSetting(id: number) {
        collectId.value = id;
        fileColleDialogMethods.toggleDialogVisible('showForm', true);
      },
      viewDetails(id: number) {
        collectId.value = id;
        fileColleDialogMethods.toggleDialogVisible('showInfo', true);
      },
    };
    return {
      ...methods,
      tabValue,
      collectId,
      resultInfo,
      fileCollectDialog,
      fileColleDialogMethods,
    };
  },
});
